import React from 'react';
import css from './SearchPage.module.css';
import { InlineTextButton } from '../../components';
import { isArrayLength } from '../../util/genericHelper';
import { recentSearches } from '../../util/constants';

function SectionCollections() {
  const [showAll, setShowAll] = React.useState(false);
  const recentSearchesData = JSON.parse(localStorage.getItem(recentSearches)) || [];
  const displayedSearches = showAll ? recentSearchesData : recentSearchesData.slice(0, 10);

  return (
    <div className={css.collectionSec}>
      <h2>Your Recent Searches</h2>
      {isArrayLength(displayedSearches) ? (
        <div className={css.collectionDesc}>
          <div className={css.collectionPills}>
            {displayedSearches?.map((search, index) => (
              <a key={index} href={search?.url}>
                {search?.label}
              </a>
            ))}
          </div>
          {recentSearchesData?.length > 10 ? (
            !showAll ? (
              <div className={css.viewAll}>
                <InlineTextButton onClick={() => setShowAll(true)}>
                  View All Related Collections
                </InlineTextButton>
              </div>
            ) : (
              <div className={css.viewAll}>
                <InlineTextButton onClick={() => setShowAll(false)}>
                  View less Related Collections
                </InlineTextButton>
              </div>
            )
          ) : null}
        </div>
      ) : (
        <p className={css.noRecentSearches}>No recent searches yet.</p>
      )}
    </div>
  );
}

export default SectionCollections;
